<template>
  <div id="background">
    <div id="allContent" class="grid grid-cols-10 rounded-xl">
      <div
        id="side"
        class="col-span-2 h-full bg-white rounded-l-xl px-4 pt-6 flex flex-col justify-between"
      >
        <div class="flex flex-col space-y-6">
          <div class="flex space-x-1.5 items-center text-blue-300 mb-6">
            <profile-picture
              v-if="((personnal || {}).profile_image || {}).isDisplayed"
              id="photo"
              size="max-w-11 w-11 h-11"
              :supports-object-fit="false"
              :specific-url="
                ((personnal || {}).profile_image || {}).value || null
              "
            />
            <div
              class="font-medium text-base-0"
              :class="{ 'pb-3': downloading }"
              v-if="personnal.prenom.isDisplayed || personnal.nom.isDisplayed"
            >
              <span v-if="personnal.prenom.isDisplayed">
                {{ personnal.prenom.value }}
              </span>
              <span v-if="personnal.nom.isDisplayed">
                {{ personnal.nom.value }}</span
              >
            </div>
          </div>
          <div
            v-if="
              (personnal.adresse.value &&
                personnal.adresse.isDisplayed &&
                personnal.adresse.value != '') ||
              (personnal.email.value &&
                personnal.email.isDisplayed &&
                personnal.email.value != '') ||
              (personnal.telephone.value &&
                personnal.telephone.isDisplayed &&
                personnal.telephone.value != '')
            "
            class="flex justify-between items-center mb-4"
          >
            <div class="text-2sm text-blue-600">Coordonnées</div>
            <icon
              name="chevron-down"
              class="text-red-400"
              :class="{ 'pb-3': downloading }"
            />
          </div>
          <div class="flex flex-col space-y-3.5">
            <div
              v-if="
                personnal.date_naissance.value &&
                personnal.date_naissance.isDisplayed &&
                personnal.date_naissance.value != ''
              "
              id="date_naissance"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="cake" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                Né le
                {{
                  new Date(personnal.date_naissance.value).toLocaleDateString()
                }}
              </div>
            </div>
            <div
              v-if="
                personnal.adresse.value &&
                personnal.adresse.isDisplayed &&
                personnal.adresse.value != ''
              "
              id="adresse"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="home-user" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                {{ personnal.adresse.value }}
              </div>
            </div>
            <div
              v-if="
                personnal.telephone.value &&
                personnal.telephone.isDisplayed &&
                personnal.telephone.value != ''
              "
              id="telephone"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="phone" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                {{ personnal.telephone.value }}
              </div>
            </div>
            <div
              v-if="
                personnal.email.value &&
                personnal.email.isDisplayed &&
                personnal.email.value != ''
              "
              id="email"
              class="flex items-center space-x-1 flex-wrap"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="envelope-open" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal flex flex-wrap"
                :class="{ 'pb-3': downloading }"
              >
                <p
                  v-for="(partMail, imail) in splitedEmail"
                  :key="'partMail' + imail + partMail"
                >
                  {{ partMail }}
                </p>
              </div>
            </div>
          </div>
          <hr
            v-if="
              (personnal.adresse.value &&
                personnal.adresse.isDisplayed &&
                personnal.adresse.value != '') ||
              (personnal.email.value &&
                personnal.email.isDisplayed &&
                personnal.email.value != '') ||
              (personnal.telephone.value &&
                personnal.telephone.isDisplayed &&
                personnal.telephone.value != '')
            "
          />
          <div
            v-if="
              (personnal.site_web.value &&
                personnal.site_web.isDisplayed &&
                personnal.site_web.value != '') ||
              (personnal.linkedin.value &&
                personnal.linkedin.isDisplayed &&
                personnal.linkedin.value != '')
            "
            class="flex justify-between items-center mb-4"
          >
            <div class="text-2sm text-blue-600">Web</div>
            <icon
              name="chevron-down"
              class="text-red-400"
              :class="{ 'pb-3': downloading }"
            />
          </div>
          <div class="flex flex-col space-y-3.5">
            <div
              v-if="
                personnal.site_web.value &&
                personnal.site_web.isDisplayed &&
                personnal.site_web.value != ''
              "
              id="site_web"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="monitor" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                {{ personnal.site_web.value }}
              </div>
            </div>
            <div
              v-if="
                personnal.linkedin.value &&
                personnal.linkedin.isDisplayed &&
                personnal.linkedin.value != ''
              "
              id="linkedin"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="link" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                {{ personnal.linkedin.value }}
              </div>
            </div>
          </div>
          <hr
            v-if="
              (personnal.site_web.value &&
                personnal.site_web.isDisplayed &&
                personnal.site_web.value != '') ||
              (personnal.linkedin.value &&
                personnal.linkedin.isDisplayed &&
                personnal.linkedin.value != '')
            "
          />
          <div class="flex flex-col space-y-3.5">
            <div
              v-if="
                personnal.moyen_transport.isDisplayed &&
                personnal.moyen_transport.value.filter(
                  (m) => !['Autres', 'Aucun'].includes(m)
                ).length > 0
              "
              id="moyen_transport"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="truck" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                {{
                  personnal.moyen_transport.value
                    .filter((m) => !['Autres', 'Aucun'].includes(m))
                    .join(', ')
                }}
              </div>
            </div>
            <div
              v-if="
                personnal.travailleur_handicape.value &&
                personnal.travailleur_handicape.isDisplayed
              "
              id="travailleur_handicape"
              class="flex items-center space-x-1"
            >
              <div class="p-2 rounded-full bg-blue-10">
                <icon name="file-user" class="text-blue-300 w-3 h-3" />
              </div>
              <div
                class="text-2xs text-blue-600 font-normal"
                :class="{ 'pb-3': downloading }"
              >
                RQTH
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col">
          <hr />
          <div class="w-full flex items-center justify-start py-3">
            <icon name="logo-neopass-dark-reduce" class="text-indigo-600" />
            <p
              class="text-indigo-600 font-semibold text-lg"
              font-family="MADEEvolveSans-Bold, MADE Evolve Sans, Montserrat"
              :class="{ 'pb-6': downloading }"
            >
              neopass
            </p>
          </div>
        </div>
      </div>
      <div id="content" class="col-span-8 rounded-r-xl px-5 pb-8">
        <div class="h-3/12 w-full">
          <div
            id="title"
            class="relative mt-8 h-10/12 grid grid-cols-12 w-full"
          >
            <div class="col-span-3 relative">
              <illustration
                v-if="typeDashboard === 'Dashboard'"
                class="absolute -top-1.5"
                name="cv-dashboard-homme"
              />
              <illustration
                v-if="typeDashboard === 'Dashboard2'"
                class="absolute -top-1.5"
                name="cv-dashboard-femme"
              />
            </div>
            <div class="col-span-9 bg-white rounded-r-xl">
              <div
                class="pl-28 pr-6 flex flex-col justify-center h-full space-y-1"
              >
                <div class="pl-2">
                  <div class="text-base-2 text-blue-300">
                    {{ name }}
                  </div>
                  <div class="text-xs text-blue-600">
                    {{ description != '' ? '“' + description + '”' : '' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="h-9/12 flex space-x-7 pb-5">
          <div class="w-130 grid grid-cols-2 gap-x-3.5 gap-y-5">
            <div class="col-span-2 grid grid-cols-2 h-48 gap-x-3.5">
              <!-- BEGIN COMPETENCES -->
              <div
                id="competences"
                class="col-span-1 bg-red-600 rounded-lg overflow-hidden h-full"
                :class="{
                  'p-3.5': !downloading,
                  'px-3.5 py-1': downloading,
                }"
              >
                <div
                  class="flex flex-col h-full"
                  :class="{ 'space-y-1': !downloading }"
                >
                  <div class="flex justify-center space-x-1 items-center">
                    <div
                      class="bg-red-300 p-1.5 rounded-full flex justify-center items-center"
                    >
                      <icon name="check" class="text-red-600 w-4 h-4" />
                    </div>
                    <p
                      class="text-red-300 text-base-2 font-medium"
                      :class="{ 'pb-4': downloading }"
                    >
                      Compétences
                    </p>
                  </div>
                  <div
                    class="text-sm text-red-300 flex flex-col space-y-0.5 items-center justify-center text-center h-full"
                    :class="{ 'pb-15': downloading }"
                  >
                    <div
                      v-for="comp in listCompetences"
                      :key="comp.value + 'dashboard'"
                    >
                      {{ comp.value }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- END COMPETENCES -->

              <!-- BEGIN ATOUTS -->
              <div
                id="atouts"
                class="col-span-1 bg-white rounded-lg overflow-hidden h-full"
                :class="{
                  'p-3.5': !downloading,
                  'px-3.5 py-1': downloading,
                }"
              >
                <div class="flex flex-col space-y-1 h-full">
                  <div class="flex justify-center space-x-1 items-center">
                    <div
                      class="bg-blue-25 p-2.5 rounded-full flex justify-center items-center"
                    >
                      <icon
                        name="person-add"
                        class="text-blue-600 w-2.5 h-2.5"
                      />
                    </div>
                    <p
                      class="text-blue-600 text-base-2 font-medium"
                      :class="{ 'pb-4': downloading }"
                    >
                      Valeurs
                    </p>
                  </div>
                  <div
                    class="text-sm text-blue-600 flex flex-col space-y-0.5 items-center justify-center text-center h-full"
                    :class="{ 'pb-15': downloading }"
                  >
                    <div v-for="atout in listAtouts" :key="atout">
                      {{ atout }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- END ATOUTS -->
            </div>

            <!-- BEGIN BESOINS -->
            <div
              id="needs"
              class="col-start-1 col-span-2 h-40 bg-white rounded-xl p-3.5"
            >
              <div class="grid grid-cols-2 space-x-5">
                <div class="flex flex-col space-y-2.5">
                  <p class="font-medium text-base-2 text-blue-300">
                    Besoins au travail
                  </p>
                  <illustration name="teamwork" />
                </div>
                <div class="flex items-center h-full">
                  <ul
                    class="flex flex-col list-disc text-red-600 text-base-2 appearance-none"
                    :class="{
                      'space-y-0': browser != 'firefox',
                      'space-y-1': browser == 'firefox',
                    }"
                  >
                    <li v-for="need in listNeeds" :key="need">
                      <div
                        class="text-blue-300 text-xs"
                        :class="{
                          'transform -translate-y-2':
                            downloading && browser != 'firefox',
                        }"
                      >
                        {{ need }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- END BESOINS -->

            <!-- BEGIN CENTRES D'INTÉRÊTS -->
            <div
              class="col-start-1 col-span-2 h-28 grid grid-cols-3 gap-x-3.5 text-blue-600"
            >
              <div
                v-for="(hobbie, ihobbie) in hobbies.filter(
                  (h) => h.isDisplayed
                )"
                :key="'hobbie' + ihobbie"
                :id="'hobbie' + ihobbie"
                class="bg-red-50 rounded-lg flex items-center py-2.5 px-4"
              >
                <div
                  class="flex flex-col space-y-2 w-full"
                  :class="{ 'pb-3': downloading }"
                >
                  <div class="flex justify-between w-full items-center">
                    <img
                      v-if="hobbie.image && hobbie.image != ''"
                      :src="hobbie.image"
                      class="object-cover h-13 w-13 rounded-md"
                    />
                    <div
                      v-if="hobbie.icon && hobbie.icon != ''"
                      class="rounded-full bg-blue-600 p-2"
                    >
                      <icon :name="hobbie.icon" class="text-white w-6 h-6" />
                    </div>
                  </div>
                  <p class="text-xs text-blue-300">
                    {{ hobbie.value }}
                  </p>
                </div>
              </div>
            </div>
            <!-- END CENTRES D'INTÉRÊTS -->
          </div>

          <div class="w-4/10 grid grid-cols-2 gap-x-3.5 gap-y-7">
            <div class="col-span-2 grid grid-cols-2 h-26 gap-x-3.5">
              <!-- BEGIN FORMATIONS -->
              <div
                id="formation"
                class="col-span-1 row-span-1 bg-blue-300 text-white rounded-xl relative p-2.5"
              >
                <div class="absolute -top-5 left-4 p-2 bg-blue-25 rounded-full">
                  <icon name="certificate" class="text-blue-600" />
                </div>
                <div
                  v-if="theFormation != null && theFormation != undefined"
                  class="flex flex-col items-center justify-center h-full"
                  :class="{ 'pb-3': downloading }"
                >
                  <div class="text-center text-xs">
                    {{ theFormation.value.value.intitule_parcours }}
                  </div>
                  <div class="text-center text-xs">
                    {{ niveauFormation }}
                  </div>
                </div>
              </div>
              <!-- END FORMATIONS -->

              <!-- BEGIN LANGUES -->
              <div
                id="langues"
                class="col-span-1 row-span-1 bg-blue-50 text-blue-600 rounded-xl relative p-2.5 flex items-center justify-center"
                :class="{ 'pb-3': downloading }"
              >
                <div class="absolute -top-5 left-4 p-2 bg-blue-25 rounded-full">
                  <icon name="chats-dots" class="text-blue-400" />
                </div>
                <div
                  v-if="langues.filter((l) => l.isDisplayed).length > 0"
                  class="flex flex-col items-center justify-center"
                >
                  <div
                    v-for="(langue, ilangue) in langues.filter(
                      (l) => l.isDisplayed
                    )"
                    :key="ilangue"
                    class="text-center text-xs"
                  >
                    {{ langue.value.name }}
                    {{ niveaux[langue.value.niveau] }}
                  </div>
                </div>
              </div>
              <!-- END LANGUES -->
            </div>

            <!-- BEGIN CLES DE REUSSITE -->
            <div
              id="success"
              class="col-span-2 bg-white h-94 rounded-lg px-3.5 flex flex-col items-center shadow"
              :class="{
                'py-0': isSucessIllustrationDisplayed && success.value.all,
                'py-4': !isSucessIllustrationDisplayed,
                'py-2': isSucessIllustrationDisplayed,
              }"
            >
              <div class="w-full h-full" :class="{ 'pb-3': downloading }">
                <illustration
                  v-if="isSucessIllustrationDisplayed && !success.value.all"
                  name="illustration-cles-reussite"
                  class="w-full"
                  :class="{ 'mb-1.5': !downloading }"
                />
                <illustration
                  v-if="isSucessIllustrationDisplayed && success.value.all"
                  name="illustration-cles-reussite"
                  class="w-full"
                  width="268"
                  height="326"
                  viewBox="79 0 89 99"
                  :class="{ 'mb-1.5': !downloading }"
                />
                <div
                  v-if="
                    !success.value.all &&
                    (sucessValues.workplace.length > 0 ||
                      sucessValues.conditions.length > 0 ||
                      sucessValues.teamwork.length > 0 ||
                      sucessValues.office.length > 0)
                  "
                  class="flex flex-col p-1 px-4 h-full"
                >
                  <div class="text-blue-300 text-base-2 mb-2">
                    Clés de réussite
                  </div>
                  <div
                    class="flex flex-col h-full"
                    :class="{
                      'space-y-2':
                        !downloading && isSucessIllustrationDisplayed,
                      'justify-around': !isSucessIllustrationDisplayed,
                    }"
                  >
                    <div
                      v-if="sucessValues.workplace.length > 0"
                      class="flex items-center text-xs space-x-1 font-normal"
                    >
                      <div class="bg-red-600 p-2 rounded-full">
                        <icon name="desktop" class="text-red-300 w-2.5 h-2.5" />
                      </div>
                      <div :class="{ 'pb-3': downloading }">
                        {{
                          sucessValues.workplace.join(', ')[0].toUpperCase() +
                          sucessValues.workplace.join(', ').slice(1)
                        }}
                      </div>
                    </div>
                    <div
                      v-if="sucessValues.conditions.length > 0"
                      class="flex items-center text-xs space-x-1 font-normal"
                    >
                      <div class="bg-blue-600 p-2 rounded-full">
                        <icon name="clock-1" class="text-white w-2.5 h-2.5" />
                      </div>
                      <div :class="{ 'pb-3': downloading }">
                        {{
                          sucessValues.conditions.join(', ')[0].toUpperCase() +
                          sucessValues.conditions.join(', ').slice(1)
                        }}
                      </div>
                    </div>
                    <div
                      v-if="sucessValues.teamwork.length > 0"
                      class="flex items-center text-xs space-x-1 font-normal"
                    >
                      <div class="bg-blue-100 p-2 rounded-full">
                        <icon
                          name="users-group"
                          class="text-white w-2.5 h-2.5"
                        />
                      </div>
                      <div :class="{ 'pb-3': downloading }">
                        {{
                          sucessValues.teamwork.join(', ')[0].toUpperCase() +
                          sucessValues.teamwork.join(', ').slice(1)
                        }}
                      </div>
                    </div>
                    <div
                      v-if="sucessValues.office.length > 0"
                      class="flex items-center text-xs space-x-1 font-normal"
                    >
                      <div class="bg-blue-50 p-2 rounded-full">
                        <icon
                          name="grid-square-plus"
                          class="text-white w-2.5 h-2.5"
                        />
                      </div>
                      <div :class="{ 'pb-3': downloading }">
                        {{ sucessValues.office.join(', ') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END CLES DE REUSSITE -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfilePicture from './../../../components/ProfilePicture.vue';
import Illustration from './../../../components/Illustration.vue';
import Icon from './../../../components/Icon.vue';
import Constants from './../../../constants';

export default {
  components: {
    ProfilePicture,
    Illustration,
    Icon,
  },

  props: {
    color: {
      type: String,
      required: false,
      default: 'teal',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    personnal: Object,
    formations: Array,
    atouts: Object,
    competences: Object,
    success: Object,
    needs: Object,
    langues: Array,
    hobbies: Array,
    typeDashboard: {
      type: String,
      required: false,
      default: 'Dashboard',
    },
  },

  data() {
    return {
      niveaux: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'],
      constants: Constants,
    };
  },

  computed: {
    ...mapGetters({
      backdoor: 'app/backdoor',
      downloading: 'curriculumVitae/downloading',
    }),

    splitedEmail() {
      return (
        this.personnal.email.value.split('@')[0] +
        '@' +
        this.personnal.email.value.split('@')[1]
      );
    },

    colorBgLight() {
      switch (this.color) {
        case 'yellow':
          return 'bg-yellow-100';
        case 'pink':
          return 'bg-pink-100';
        case 'teal':
          return 'bg-teal-100';
        case 'orange':
          return 'bg-orange-100';
        case 'gray':
          return 'bg-gray-200';

        default:
          return 'bg-teal-100';
      }
    },
    colorBgNormal() {
      switch (this.color) {
        case 'yellow':
          return 'bg-yellow-600';
        case 'pink':
          return 'bg-pink-600';
        case 'teal':
          return 'bg-teal-600';
        case 'orange':
          return 'bg-orange-600';
        case 'gray':
          return 'bg-gray-600';

        default:
          return 'bg-teal-600';
      }
    },
    colorText() {
      switch (this.color) {
        case 'yellow':
          return 'text-yellow-600';
        case 'pink':
          return 'text-pink-600';
        case 'teal':
          return 'text-teal-600';
        case 'orange':
          return 'text-orange-600';
        case 'gray':
          return 'text-gray-600';

        default:
          return 'text-teal-600';
      }
    },
    listCompetences() {
      this.backdoor; //for reactivity

      return [...new Set(Object.values(this.competences).flat())].filter(
        (cmp) => cmp.isDisplayed
      );
    },

    listAtouts() {
      this.backdoor;

      let defaultValues =
        ((this.atouts || {}).value || {}).default === undefined
          ? 0
          : this.atouts.value.default.filter((a) => a && a != '');
      let persoValues =
        ((this.atouts || {}).value || {}).perso === undefined
          ? 0
          : this.atouts.value.perso
              .filter((a) => a.isDisplayed)
              .map((a) => a.value);

      return [...defaultValues, ...persoValues];
    },

    listNeeds() {
      this.backdoor;

      let defaultValues =
        ((this.needs || {}).value || {}).default === undefined
          ? 0
          : this.needs.value.default.filter((a) => a && a != '');
      let persoValues =
        ((this.needs || {}).value || {}).perso === undefined
          ? 0
          : this.needs.value.perso
              .filter((a) => a.isDisplayed)
              .map((a) => a.value);

      return [...defaultValues, ...persoValues];
    },

    theFormation() {
      return this.formations.filter((f) => f.isDisplayed)[0];
    },

    niveauFormation() {
      return Constants.cvdatas.level_formations[
        this.theFormation.value.value.niveau_cursus
      ];
    },

    sucessValues() {
      //First, take off all values when all values are selected
      let workplace = Object.keys(this.success.value.workplace).reduce(
        (acc, wp) => {
          return {
            ...acc,
            [wp]: Constants.cvdatas.success.workplace[wp].every((data) =>
              this.success.value.workplace[wp].includes(data)
            )
              ? []
              : this.success.value.workplace[wp],
          };
        },
        {}
      );
      let conditions = Object.keys(this.success.value.conditions).reduce(
        (acc, condition) => {
          return {
            ...acc,
            [condition]: Constants.cvdatas.success.conditions[condition].every(
              (data) => this.success.value.conditions[condition].includes(data)
            )
              ? []
              : this.success.value.conditions[condition],
          };
        },
        {}
      );
      let teamwork = Object.keys(this.success.value.teamwork).reduce(
        (acc, tw) => {
          return {
            ...acc,
            [tw]: Constants.cvdatas.success.teamwork[tw].every((data) =>
              this.success.value.teamwork[tw].includes(data)
            )
              ? []
              : this.success.value.teamwork[tw],
          };
        },
        {}
      );

      return {
        workplace: [...new Set(Object.values(workplace).flat())],
        conditions: [...new Set(Object.values(conditions).flat())],
        teamwork: [...new Set(Object.values(teamwork).flat())],
        office: Object.keys(this.success.value.office).filter(
          (k) => this.success.value.office[k] === 'Oui'
        ),
      };
    },

    successLength() {
      /*
                30 caractères pour une ligne.
                1 ligne comptée en plus pour chaque item où il y a du contenu, à part la première.
                => 9 lignes max pour garder l'illustration
            */
      let totalLines = 0;
      Object.values(this.sucessValues).forEach((suc, k) => {
        let lineByItem = Math.ceil(suc.join(', ').length / 30);
        totalLines += lineByItem;
        totalLines += k > 0 && lineByItem > 0 ? 1 : 0; //Add one line for each item
      });

      return totalLines;
    },

    isSucessIllustrationDisplayed() {
      return this.successLength < 10;
    },

    browser() {
      let userAgent = navigator.userAgent;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        return 'chrome';
      }
      if (userAgent.match(/firefox|fxios/i)) {
        return 'firefox';
      }
      if (userAgent.match(/safari/i)) {
        return 'safari';
      }
      if (userAgent.match(/opr\//i)) {
        return 'opera';
      }
      if (userAgent.match(/edg/i)) {
        return 'edge';
      }

      return 'No browser detection';
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 64px;
  text-align: center;
}
h2 {
  font-size: 48px;
  text-align: center;
}
h3 {
  font-size: 32px;
  text-align: center;
}
h4 {
  font-size: 28px;
  text-align: center;
}
h5 {
  font-size: 24px;
  text-align: center;
}
h6 {
  font-size: 21.3px;
  text-align: center;
}

.text-2xs {
  font-size: 10.7px;
}
.text-2sm {
  font-size: 12px;
}
.text-xs {
  font-size: 13.3px;
}
.text-sm {
  font-size: 14.5px;
}
.text-base-0 {
  font-size: 16px;
}
.text-base {
  font-size: 17.3px;
}
.text-base-2 {
  font-size: 18.7px;
}
.text-lg {
  font-size: 21.3px;
}
.text-xl {
  font-size: 24px;
}
.text-2xl {
  font-size: 28px;
}
.text-3xl {
  font-size: 32px;
}
.text-3\.5xl {
  font-size: 37.3px;
}
.text-4xl {
  font-size: 48px;
}
.text-5xl {
  font-size: 64px;
}
.text-plusButton {
  font-size: 41.3px;
}

#side {
  height: 746px;
}

#color-block-1 {
  height: 136px !important;
  width: 77px !important;
}

#background {
  background: #ffffff;
  padding: 24px 24px;
}

#allContent {
  box-shadow: -15px 25px 50px rgba(11, 30, 91, 0.2);
}

#content {
  background: rgba(11, 30, 91, 0.03);
}

#competences {
  box-shadow: 15px 15px 25px rgba(255, 215, 215, 0.5);
}

#needs {
  box-shadow: 0px 0px 20px rgba(148, 163, 184, 0.04);
}

#formation {
  box-shadow: 0px 0px 20px rgba(148, 163, 184, 0.04);
}

#langues {
  box-shadow: 0px 0px 20px rgba(148, 163, 184, 0.04);
}
</style>
